import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  highlight: {
    backgroundColor: '#FFFFFF',
    opacity: 0.2,
    position: 'absolute',
  },
});
